// you can combine multiple reducers see the commented code in this file
import { combineReducers } from 'redux';

// import user from './user';
import ThemeOptions from './ThemeOption'
import User from './UserReducer'

export default combineReducers({
  ThemeOptions,
  User
});